import { useCallback, useEffect } from 'react';
import { mockComplexVisualizationMessage, mockMessageWithToolsAndCards } from './mockMessages';

/**
 * Custom hook for handling mock data in development
 * Isolates testing and development concerns from main conversation logic
 */
export function useMockData({ enableMockData, isVisible, setActiveToolEvents, setStreamingMessage, setStreamStatus, setMessages }) {
  /**
   * Load mock data for development and testing
   */
  const loadMockData = useCallback(() => {
    console.log('🚀 Loading mock data for development...');

    // Load basic messages
    // setMessages(mockMessages);

    // Simulate active tools and streaming message
    if (mockMessageWithToolsAndCards) {
      setActiveToolEvents(mockMessageWithToolsAndCards.activeToolEvents);
      setStreamingMessage(mockMessageWithToolsAndCards.message);
      setStreamStatus(mockMessageWithToolsAndCards.streamStatus);
    }

    console.log('✅ Mock data loaded successfully');
  }, [setActiveToolEvents, setStreamingMessage, setStreamStatus]);

  /**
   * Add a mock message with complex visualizations
   */
  const addComplexVisualizationMock = useCallback(() => {
    console.log('📊 Adding message with complex visualizations...');
    setMessages((prevMessages) => [...prevMessages, mockComplexVisualizationMessage]);
  }, [setMessages]);

  /**
   * Load mock data when useMockData option is enabled
   */
  useEffect(() => {
    if (enableMockData && isVisible) {
      console.log('🎭 Mock mode enabled, loading test data...');
      loadMockData();
      addComplexVisualizationMock();
    }
  }, [enableMockData, isVisible, loadMockData, addComplexVisualizationMock]);

  return {
    loadMockData,
    addComplexVisualizationMock,
  };
}
